import React, { useState, useEffect, useContext, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Checkbox,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormHelperText,
  Radio,
  Grid,
  Link,
  TextField,
  RadioGroup,
  MenuItem,
} from '@material-ui/core';
import NoticeDialog from '../../../../components/DialogModals/NoticeDialog';
import LaunchedOutlinedIcon from '@material-ui/icons/LaunchOutlined';
import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';
import CircularProgress from '@material-ui/core/CircularProgress';
import CurrentUserContext from '../../../../contexts/CurrentUserContext';
import * as moment from 'moment';
import * as EmailValidator from 'email-validator';
import { Document, Page, pdfjs } from 'react-pdf';
import PDFSingleViewer from '../../../../components/PDFSingleViewer';
import ImgSingleViewer from '../../../../components/ImgSingleViewer';
import { fileSelectHandler } from '../../../../util/fileHandling';
import Button from '../../../../components/Button';
import DateSelect from '../../../../components/DateSelect';
import SearchableSelect from '../../../../components/SearchableSelect';
import PhoneInput from '../../../../components/PhoneInput';
import AreYouSureModal from '../../../../components/DialogModals/AreYouSureModal';
import { STATES_LIST } from '../../../../constants';
import {
  fetchPatientById,
  getUserByIdReq,
  getGuardianDependentsReq,
  getConciergeMemberInfo,
  isEmailAvailable,
} from '../../../../services/api';
import { checkBothPatientAndProviderId, fetchTebraInsurancesList } from '../../../../services/api/admin';
import MobileDetect from 'mobile-detect';
import ProviderRestrictedModal from '../../../ProviderAdminPatients/components/ProviderRestrictedModal';
import PatientRestrictForProvider from '../../../ProviderAdminPatients/components/PatientRestrictForProvider';
import PatientRestrictForAppt from '../../PatientRestrictForAppt';
import PatientNotAllowToBookApptModal from '../../PatientNotAllowToBookApptModal';
import EmailFindModal from '../../EmailFindModal';
import '../../style.css';
import { checkProviderEligible } from '../../../../services/api/admin';
import Autocomplete from '@material-ui/lab/Autocomplete';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${
  pdfjs.version
}/pdf.worker.js`;

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};

const validatePhone = num => {
  return num.replace(/[a-z\W]/gi, '').length === 10 && !/[a-z]/i.test(num);
};

function PatientInformationForm(props) {
  const {
    setPropImages,
    setPropImageBack,
    setPropImageFront,
    imagesProps,
    history,
    location,
    isAptRequest,
    onSubmit,
    patient,
    onCancel,
    onRestrictedClose,
    onRestrictedCloseForPatient,
    showProviderRestrictedModal,
    showPatientRestrictPopUp,
    providerFamily,
    currentUserInfo,
    setCurrentPatient,
    onClose,
    provider,
    classes: {
      input,
      container,
      formControl,
      actions,
      submitButton,
      cancelButton,
      labelWithLink,
      warning,
      selectPatient,
      formItem,
      loadingCircle,
      helperText,
      attachmentsBtn,
      insuranceLabel,
      addressLabel,
    },
  } = props;

  const [formInfo, setFormInfo] = useState({});
  const [validationErrors, setValidationErros] = useState({});
  const [bookForPatient, setBookForPatient] = useState();
  const [primPatient, setPrimPatient] = useState();
  const [primPlusDependentPatients, setPrimPlusDependentPatients] = useState();
  const [pageLoading, setPageLoading] = useState(true);
  const [openLoginWarning, setOpenLoginWarning] = useState(false);
  const [previewFront, setPreviewFront] = useState(true)
  const [previewBack, setPreviewBack] = useState(true)
  const [popNotice, setPopNotice] = useState('');
  const [openImgModal, setOpenImgModal] = useState(false);
  const [currentImg, setCurrentImg] = useState('');
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [currentPDF, setCurrentPDF] = useState([]);
  const [addressConfirmed, setAddressConfirmed] = useState(false);
  const [insuranceConfirmed, setInsuranceConfirmed] = useState(false);
  const [restrictReason, setRestrictReason] = useState('');
  const [openModal, setToOpen] = useState(false);
  const [isRestricted, setIsRestricted] = useState(false);
  const [isPatientRestrict, setIsPatientRestrict] = useState(false);
  const [isNotAllowToBook, setNotAllowToBook] = useState(false);
  const [showPatientRestrictModal, setShowPatientRestrictModal] = useState(
    false
  );
  const [insurancePlans, setInsurancePlans] = useState([]);

  const { currentPatient } = useContext(CurrentUserContext);
  const md = new MobileDetect(window.navigator.userAgent);
  const isMobile = md.mobile();
  const myRef = useRef(null);

    // These are insurances that has no group number.
  const insuranceWithoutGroupNumber = ['729d4056-09e9-4b3a-a37b-8a236bb154ab', '74a91228-6503-4851-922d-d4e23bc402ff', '1d1dae88-1d16-4e3b-a63d-a32e74a88e0a']

  useEffect(() => {
    (async () => {
      const response = await fetchTebraInsurancesList();
      setInsurancePlans(response.data);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setPageLoading(true);
      try {
        if (patient && patient.id) {
          let customPatient = await customPatientDetails(patient.id);
          if (patient.id === setCurrentPatient && setCurrentPatient.id) {
            setPrimPatient(customPatient);
            setBookForPatient(customPatient);
            if (!bookForPatient) {
              setFormInfo({
                firstName: customPatient.firstName,
                lastName: customPatient.lastName,
                preferredName: customPatient.preferredName,
                email: customPatient.email,
                phone: customPatient.phone,
                addressLine1: customPatient.addressLine1 || '',
                addressLine2: customPatient.addressLine2 || '',
                city: customPatient.city || '',
                state: customPatient.state || '',
                zipcode: customPatient.zipcode || '',
                insuranceName: customPatient.tebraInsurance?.planName || customPatient.insuranceName || '',
                insurancePlanId: customPatient.insurancePlanId || null,
                insuranceId: customPatient.insuranceId || '',
                payerId: customPatient.payerId || '',
                groupNumber: customPatient.groupNumber || '',
                gender: customPatient.gender,
                patientReason: '',
                existingPatient: true,
                birthdate: customPatient.birthdate,
                termsOfUse: true,
                privPolicy: true,
              });
            }
            const dependetPatients = await getGuardianDependentsReq(
              customPatient.id,
              provider.id
            );
            setPrimPlusDependentPatients([customPatient, ...dependetPatients]);
          } else {
            if (setCurrentPatient && setCurrentPatient.id) {
              const customSetPatient = await customPatientDetails(
                setCurrentPatient && setCurrentPatient.id
              );

              setPrimPatient(customSetPatient);
              setBookForPatient(customSetPatient);
              if (!bookForPatient) {
                setFormInfo({
                  firstName: customSetPatient.firstName,
                  lastName: customSetPatient.lastName,
                  preferredName: customSetPatient.preferredName,
                  email: customSetPatient.email,
                  phone: customSetPatient.phone,
                  addressLine1: customSetPatient.addressLine1 || '',
                  addressLine2: customSetPatient.addressLine2 || '',
                  city: customSetPatient.city || '',
                  state: customSetPatient.state || '',
                  zipcode: customSetPatient.zipcode || '',
                  insuranceName: customSetPatient.tebraInsurance?.planName || customSetPatient.insuranceName || '',
                  insurancePlanId: customSetPatient.insurancePlanId || null,
                  insuranceId: customSetPatient.insuranceId || '',
                  payerId: customSetPatient.payerId || '',
                  groupNumber: customSetPatient.groupNumber || '',
                  gender: customSetPatient.gender,
                  patientReason: '',
                  existingPatient: true,
                  birthdate: customSetPatient.birthdate,
                  termsOfUse: true,
                  privPolicy: true,
                });
              }
              const dependetPatients = await getGuardianDependentsReq(
                customPatient.id,
                provider.id
              );
              setPrimPlusDependentPatients([
                customPatient,
                ...dependetPatients,
              ]);
            }
          }
        } else {
          setFormInfo({
            firstName: '',
            lastName: '',
            preferredName: '',
            email: '',
            phone: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            zipcode: '',
            insuranceName: '',
            insurancePlanId: null,
            insuranceId: '',
            payerId: '',
            groupNumber: '',
            gender: '',
            patientReason: '',
            existingPatient: false,
            birthdate: null,
            termsOfUse: false,
            privPolicy: false,
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        setPageLoading(false);
      }
    })();
  }, [currentPatient, setCurrentPatient]);

  useEffect(() => {
    (async () => {
      setPageLoading(true);
      try {
        // if (primPatient && primPatient.id && provider && provider.id) {
        //   const checkingPatientStatus = await checkBothPatientAndProviderId(
        //     primPatient.id,
        //     provider.id
        //   );
        //   if (checkingPatientStatus.data === 'Patient have access') {
        //     const now = new Date().getTime();
        //     const then = new Date(primPatient.birthdate).getTime();
        //     const checkAge =
        //       (now - then) / 1000 / 60 / 60 / 24 / 365 < 18
        //         ? 'below_18'
        //         : 'above_18'
        //         ? 'above_18'
        //         : '';
        //     if (
        //       provider.preferredAge === 'all' &&
        //       provider.preferredGender === 'all'
        //     ) {
        //       setIsRestricted(false);
        //       setPageLoading(false);
        //     } else {
        //       if (checkAge === provider.preferredAge) {
        //         if (provider.preferredGender === 'all') {
        //           setIsRestricted(false);
        //           setPageLoading(false);
        //         } else if (provider.preferredGender == primPatient.gender) {
        //           setIsRestricted(false);
        //           setPageLoading(false);
        //         } else {
        //           if (
        //             provider.preferredAge === 'above_18' &&
        //             provider.preferredGender === 'female'
        //           ) {
        //             setRestrictReason('female/above_18');
        //           } else {
        //             setRestrictReason(provider.preferredAge);
        //           }
        //           setIsPatientRestrict(true);
        //           setPageLoading(false);
        //         }
        //       } else if (provider.preferredAge === 'all') {
        //         if (provider.preferredGender === 'all') {
        //           setIsRestricted(false);
        //           setPageLoading(false);
        //         } else if (provider.preferredGender == primPatient.gender) {
        //           setIsRestricted(false);
        //           setPageLoading(false);
        //         } else {
        //           if (provider.preferredGender === 'male') {
        //             setRestrictReason('male/all');
        //           } else {
        //             setRestrictReason('female/all');
        //           }
        //           setIsPatientRestrict(true);
        //           setPageLoading(false);
        //         }
        //       } else {
        //         if (provider.preferredGender == primPatient.gender) {
        //           if (checkAge === provider.preferredAge) {
        //             setIsRestricted(false);
        //             setPageLoading(false);
        //           } else {
        //             setRestrictReason(provider.preferredAge);
        //             setIsPatientRestrict(true);
        //             setPageLoading(false);
        //           }
        //         } else {
        //           if (provider.preferredGender === 'all') {
        //             setRestrictReason(provider.preferredAge);
        //           } else {
        //             setRestrictReason(provider.preferredGender);
        //           }
        //           setIsPatientRestrict(true);
        //           setPageLoading(false);
        //         }
        //       }
        //     }
        //   } else if (
        //     checkingPatientStatus.data === 'Provider is restricted by admin'
        //   ) {
        //     setIsRestricted(true);
        //     setPageLoading(false);
        //   } else {
        //     const now = new Date().getTime();
        //     const then = new Date(primPatient.birthdate).getTime();
        //     const checkAge =
        //       (now - then) / 1000 / 60 / 60 / 24 / 365 < 18
        //         ? 'below_18'
        //         : 'above_18'
        //         ? 'above_18'
        //         : '';
        //     if (
        //       provider.preferredAge === 'all' &&
        //       provider.preferredGender === 'all'
        //     ) {
        //       setIsRestricted(false);
        //       setPageLoading(false);
        //     } else {
        //       if (checkAge === provider.preferredAge) {
        //         if (provider.preferredGender === 'all') {
        //           setIsRestricted(false);
        //           setPageLoading(false);
        //         } else if (provider.preferredGender == primPatient.gender) {
        //           setIsRestricted(false);
        //           setPageLoading(false);
        //         } else {
        //           if (
        //             provider.preferredAge === 'above_18' &&
        //             provider.preferredGender === 'female'
        //           ) {
        //             setRestrictReason('female/above_18');
        //           } else {
        //             setRestrictReason(provider.preferredAge);
        //           }
        //           setIsPatientRestrict(true);
        //           setPageLoading(false);
        //         }
        //       } else if (provider.preferredAge === 'all') {
        //         if (provider.preferredGender === 'all') {
        //           setIsRestricted(false);
        //           setPageLoading(false);
        //         } else if (provider.preferredGender == primPatient.gender) {
        //           setIsRestricted(false);
        //           setPageLoading(false);
        //         } else {
        //           if (provider.preferredGender === 'male') {
        //             setRestrictReason('male/all');
        //           } else {
        //             setRestrictReason('female/all');
        //           }
        //           setIsPatientRestrict(true);
        //           setPageLoading(false);
        //         }
        //       } else {
        //         if (provider.preferredGender == primPatient.gender) {
        //           if (checkAge === provider.preferredAge) {
        //             setIsRestricted(false);
        //             setPageLoading(false);
        //           } else {
        //             setRestrictReason(provider.preferredGender);
        //             setIsPatientRestrict(true);
        //             setPageLoading(false);
        //           }
        //         } else {
        //           setRestrictReason(provider.preferredAge);
        //           setIsPatientRestrict(true);
        //           setPageLoading(false);
        //         }
        //       }
        //     }
        //   }
        // }
      } catch (error) {
        console.log(error);
      } finally {
        setPageLoading(false);
      }
    })();
  }, [primPatient]);
  const onClosePatientRestrictModal = () => {
    setShowPatientRestrictModal(false);
  };
  const customPatientDetails = async patientId => {
    let customPatientObj;
    const currentPatientInf = await fetchPatientById(patientId);
    const currentUserInf = await getUserByIdReq(currentPatientInf.userId);
    customPatientObj = {
      id: currentPatientInf.id,
      firstName: currentUserInf && currentUserInf.firstName,
      lastName: currentUserInf && currentUserInf.lastName,
      preferredName: currentUserInf && currentUserInf.preferredName,
      fullName:
        currentUserInf &&
        currentUserInf.firstName + ' ' + currentUserInf &&
        currentUserInf.lastName,
      email: currentUserInf && currentUserInf.email,
      phone: currentUserInf && currentUserInf.phone,
      addressLine1: currentPatientInf.addressLine1,
      addressLine2: currentPatientInf.addressLine2,
      city: currentPatientInf.city,
      state: currentPatientInf.state,
      zipcode: currentPatientInf.zipcode,
      insurancePlanId: currentPatientInf?.insurancePlanId || null,
      insuranceName: currentPatientInf.tebraInsurance?.planName || '',
      insuranceId: currentPatientInf.insuranceId,
      payerId: currentPatientInf.payerId,
      groupNumber: currentPatientInf.groupNumber,
      gender: currentPatientInf.gender,
      birthdate: currentPatientInf.birthdate,
      isGuardian: currentPatientInf.isGuardian,
      isDependent: currentPatientInf.isDependent,
    };
    return customPatientObj;
  };

  const handleChange = event => {
    if (
      event.target.name === 'termsOfUse' ||
      event.target.name === 'privPolicy'
    ) {
      setFormInfo({ ...formInfo, [event.target.name]: event.target.checked });
    } else {
      setFormInfo({ ...formInfo, [event.target.name]: event.target.value });
    }
    setValidationErros({ ...validationErrors, [event.target.name]: false });
  };

  const onChange = event => {
    // setFormInfo(previos{ email: event.target.value });
    setFormInfo({ ...formInfo, email: event.target.value });
    setValidationErros({ ...validationErrors, [event.target.name]: false });
  };

  const handleDateChange = date => {
    setFormInfo({
      ...formInfo,
      birthdate: moment.utc(date).format('MM/DD/YYYY'),
    });
    setValidationErros({
      ...validationErrors,
      birthdate: false,
    });
  };

  const inputPicCallBackProps = fileObject => {
    setPropImages(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2MB'
            : 'Please use a valid file to upload';
        setPopNotice(notice);
        myRef.current.value = null;
        setPropImages([]);
      }
    });
  };

  const inputPicFrontCallBack = fileObject => {
    setPreviewFront(true)
    setPropImageFront(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2MB'
            : 'Please use a valid file to upload';
            setPreviewFront(false)
        setPopNotice(notice);
        myRef.current.value = null;
        setPropImageFront([]);
      }
    });
  };

  const inputPicBackCallBack = fileObject => {
    setPreviewBack(true)
    setPropImageBack(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2MB'
            : 'Please use a valid file to upload';
    setPreviewBack(false)
        setPopNotice(notice);
        myRef.current.value = null;
        setPropImageBack([]);
      }
    });
  };

  const callSetImageFront = event => {
    // setImageFront([]);
    fileSelectHandler(
      event.target.files,
      inputPicFrontCallBack,
      ['jpg', 'jpeg', 'pdf'],
      1048576 // 1048576 bytes = 1MBl
    );
  };

  const callSetImageBack = event => {
    // setImageBack([]);
    fileSelectHandler(
      event.target.files,
      inputPicBackCallBack,
      ['jpg', 'jpeg', 'pdf'],
      1048576 // 1048576 bytes = 1MBl
    );
  };

  const handleOpenImg = link => {
    setOpenImgModal(true);
    setCurrentImg(link);
  };

  const handleOpenPDF = link => {
    setOpenPDFModal(true);
    setCurrentPDF(link);
  };

  const prepareForSelectComp = patients => {
    const prearedArray = (patients || []).map(patient => ({
      label: patient.firstName + ' ' + patient.lastName,
      value: patient,
    }));
    return prearedArray;
  };

  const validate = () => {
    let valid = true;
    const nextValidationErrors = {};
    if (!formInfo.firstName || !formInfo.firstName.replace(/^\s+|\s+$/gm, '')) {
      valid = false;
      nextValidationErrors.firstName = 'Required';
    }
    if (!formInfo.lastName || !formInfo.lastName.replace(/^\s+|\s+$/gm, '')) {
      valid = false;
      nextValidationErrors.lastName = 'Required';
    }
    if (!formInfo.email) {
      valid = false;
      nextValidationErrors.email = 'Required';
    } else if (!EmailValidator.validate(formInfo.email)) {
      valid = false;
      nextValidationErrors.email = 'Must be a valid email';
    }
    if (!formInfo.phone) {
      valid = false;
      nextValidationErrors.phone = 'Required';
    } else if (formInfo.phone && !validatePhone(formInfo.phone)) {
      valid = false;
      nextValidationErrors.phone = 'Must be a valid phone number';
    }
    if (!formInfo.zipcode) {
      valid = false;
      nextValidationErrors.zipcode = 'Required';
    } else if (!formInfo.zipcode.match(/^\d{5}$|^\d{5}-\d{4}$/)) {
      valid = false;
      nextValidationErrors.zipcode = 'Must be a valid zipcode';
    }
    if (!formInfo.addressLine1?.trim()) {
      valid = false;
      nextValidationErrors.addressLine1 = 'Required';
    }
    if (!formInfo.city?.trim()) {
      valid = false;
      nextValidationErrors.city = 'Required';
    }
    if (!formInfo.state?.trim()) {
      valid = false;
      nextValidationErrors.state = 'Required';
    } else if (!formInfo.state.match(/^[A-Z]{2}$/)) {
      valid = false;
      nextValidationErrors.state = 'Must be a valid 2-letter state code';
    }
    if (!formInfo.insurancePlanId) {
      valid = false;
      nextValidationErrors.insurancePlanId = 'Required';
    }
    if (!formInfo.insuranceId?.trim()) {
      valid = false;
      nextValidationErrors.insuranceId = 'Required';
    }

    // For Medicare insurance group number is not required.
    if (!formInfo.groupNumber?.trim()  && !insuranceWithoutGroupNumber?.includes(formInfo.insurancePlanId)) {
      valid = false;
      nextValidationErrors.groupNumber = 'Required';
    }
    if (!formInfo.gender) {
      valid = false;
      nextValidationErrors.gender = 'Required';
    }
    if (!formInfo.birthdate) {
      valid = false;
      nextValidationErrors.birthdate = 'Required';
    } else if (
      moment.utc(formInfo.birthdate).format('YYYY-MM-DD') === 'Invalid date'
    ) {
      valid = false;
      nextValidationErrors.birthdate = 'Invalid Date';
    }
    if (!formInfo.patientReason) {
      valid = false;
      nextValidationErrors.patientReason = 'Required';
    }
    if (!formInfo.termsOfUse) {
      nextValidationErrors.termsOfUse = 'You need to agree to our terms of use';
      valid = false;
    }

    if (!formInfo.privPolicy) {
      nextValidationErrors.privPolicy = 'You need to agree to privacy policy';
      valid = false;
    }

    if (!addressConfirmed) {
      nextValidationErrors.addressConfirmed =
        'Please confirm the address information is correct';
      valid = false;
    }

    if (!insuranceConfirmed) {
      nextValidationErrors.insuranceConfirmed =
        'Please confirm the insurance information is correct';
      valid = false;
    }
    setValidationErros(nextValidationErrors);
    return valid;
  };

  const nullifyStateAndClosePopup = () => {
    if (patient && patient.id) {
      setFormInfo({
        existingPatient: true,
      });
    } else {
      setFormInfo({
        firstName: '',
        lastName: '',
        preferredName: '',
        email: '',
        phone: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zipcode: '',
        insuranceName: '',
        insurancePlanId: null,
        insuranceId: '',
        payerId: '',
        groupNumber: '',
        gender: '',
        patientReason: '',
        existingPatient: false,
        birthdate: null,
        termsOfUse: false,
        privPolicy: false,
      });
    }
    onRestrictedClose();
  };

  const nullifyStateAndClosePatientPopup = () => {
    if (patient && patient.id) {
      setFormInfo({
        existingPatient: true,
      });
    } else {
      setFormInfo({
        firstName: '',
        lastName: '',
        preferredName: '',
        email: '',
        phone: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zipcode: '',
        insuranceName: '',
        insurancePlanId: null,
        insuranceId: '',
        payerId: '',
        groupNumber: '',
        gender: '',
        patientReason: '',
        existingPatient: false,
        birthdate: null,
        termsOfUse: false,
        privPolicy: false,
      });
    }
    onRestrictedCloseForPatient();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    const { insuranceName, insurancePlanId, insuranceId, patientReason, addressLine1, addressLine2, city, state, payerId, groupNumber, zipcode } = formInfo;

    const {
      firstName,
      lastName,
      preferredName,
      email,
      phone,
      // zipcode,
      gender,
      birthdate,
    } = formInfo.existingPatient ? bookForPatient : formInfo;
    
    if (!validate()) {
      return;
    }

    const restriction = await checkProviderEligible(birthdate, gender,provider.id)


    if (restriction.data.success === true) {
      await onSubmit({
        firstName: firstName.replace(/^\s+|\s+$/gm, ''),
        lastName: lastName.replace(/^\s+|\s+$/gm, ''),
        preferredName: preferredName.replace(/^\s+|\s+$/gm, ''),
        email,
        phone,
        addressLine1,
        addressLine2,
        city,
        state,
        zipcode,
        birthdate,
        gender,
        insurancePlanId,
        insuranceName,
        insuranceId,
        payerId,
        groupNumber,
        patientReason,
      });
    } else {
      setRestrictReason(restriction.data.data)
      setShowPatientRestrictModal(true)
    }
   
    // }
    // await onSubmit({
    //   firstName: firstName.replace(/^\s+|\s+$/gm, ''),
    //   lastName: lastName.replace(/^\s+|\s+$/gm, ''),
    //   email,
    //   phone,
    //   zipcode,
    //   birthdate,
    //   gender,
    //   insuranceName,
    //   insuranceId,
    //   patientReason,
    // });
  };
  const closePopUp = () => {
    setShowPatientRestrictModal(false)
  };
  

  const closePopUpForPatient = () => {
    setIsPatientRestrict(false);
    // setNotAllowToBook(true);
  };

  const whoAmIBookingForOptions = [
    ...prepareForSelectComp(primPlusDependentPatients),
    {
      label: 'Someone else...',
      value: 'ADD_USER',
    },
  ].concat(
    patient
      ? []
      : [
          {
            label: 'Myself',
            value: 'ME',
          },
        ]
  );

  const onClosePop = () => {
    setToOpen(false);
  };

  return pageLoading ? (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      spacing={2}
      className={loadingCircle}
    >
      <CircularProgress size={60} />
    </Grid>
  ) : (
    <Grid container spacing={0} classes={{ container: container }}>
      <Grid
        container
        spacing={2}
        classes={{
          container: styles.container,
        }}
      >
        <Grid item xs={12} className={formControl}>
          <SearchableSelect
            // placeholder={
            //   patient
            //     ? `${formInfo.firstName} ${formInfo.lastName}`
            //     : 'Myself'
            // }
            placeholder={
              patient
                ? `${primPatient && primPatient.firstName} ${primPatient &&
                    primPatient.lastName}`
                : 'Myself'
            }
            label={isAptRequest ? 'Request for' : 'Book for'}
            name={'bookOrRequestForPatient'}
            onChange={selection => {
              setFormInfo({
                ...formInfo,
                ['addressLine1']: selection.value.addressLine1,
                ['addressLine2']: selection.value.addressLine2,
                ['city']: selection.value.city,
                ['state']: (selection.value.state || '').toUpperCase().slice(0, 2),
                ['zipcode']: selection.value.zipcode,
                ['insuranceName']: selection.value.insuranceName || selection.value.tebraInsurance?.planName || '',
                ['insuranceId']: selection.value.insuranceId,
                ['insurancePlanId']: selection.value?.insurancePlanId || null,
                ['payerId']: selection.value.payerId,
                ['groupNumber']: selection.value.groupNumber,
              });
              setPrimPatient(selection.value);
              setAddressConfirmed(false);
              setInsuranceConfirmed(false);
              if (!selection.value === 'ME') return;
              else if (selection.value === 'ADD_USER') {
                setFormInfo({
                  ...formInfo,
                  ['insuranceName']: '',
                  ['insuranceId']: '',
                  ['insurancePlanId']: null,
                  ['payerId']: '',
                  ['groupNumber']: '',
                  ['addressLine1']: '',
                  ['addressLine2']: '',
                  ['city']: '',
                  ['state']: '',
                  ['zipcode']: '',
                });
                setAddressConfirmed(false);
                setInsuranceConfirmed(false);
                if (patient) {
                  history.push(
                    '/sign-up/dependent-patient-signup?redirect=back'
                  );
                } else {
                  setOpenLoginWarning(true);
                }
              } else {
                setBookForPatient(selection.value);
              }
            }}
            options={whoAmIBookingForOptions}
          />
        </Grid>
        {!formInfo.existingPatient && (
          <>
            <Grid item xs={12} className={formControl}>
              <TextField
                fullWidth
                name="firstName"
                label="First Name"
                value={formInfo.firstName || ''}
                variant="outlined"
                onChange={handleChange}
                error={validationErrors.firstName}
                helperText={validationErrors.firstName}
                className={formItem}
              />
            </Grid>

            <Grid item xs={12} className={formControl}>
              <TextField
                fullWidth
                name="lastName"
                label="Last Name"
                value={formInfo.lastName || ''}
                variant="outlined"
                onChange={handleChange}
                error={validationErrors.lastName}
                helperText={validationErrors.lastName}
                className={formItem}
              />
            </Grid>

            <Grid item xs={12} className={formControl}>
              <TextField
                fullWidth
                name="preferredName"
                label="Preferred Name"
                value={formInfo.preferredName || ''}
                variant="outlined"
                onChange={handleChange}
                error={validationErrors.preferredName}
                helperText={validationErrors.preferredName}
                className={formItem}
              />
            </Grid>

            <Grid item xs={12} className={formControl}>
              {(currentUserInfo && !currentUserInfo.isProvider) ||
              currentUserInfo === null ? (
                <TextField
                  fullWidth
                  label="Email"
                  value={formInfo.email || ''}
                  variant="outlined"
                  name="email"
                  onChange={onChange}
                  error={validationErrors.email}
                  helperText={validationErrors.email}
                  inputProps={{
                    onBlur: async () => {
                      const available = await isEmailAvailable(formInfo.email);
                      if (formInfo.email && !available) {
                        setToOpen(!available);
                        setValidationErros({
                          ...validationErrors,
                          // email: 'this email is already in use',
                        });
                        // setToOpen(true);
                      }
                    },
                  }}
                  className={formItem}
                />
              ) : (
                <TextField
                  fullWidth
                  name="email"
                  label="Email"
                  value={formInfo.email || ''}
                  variant="outlined"
                  onChange={handleChange}
                  error={validationErrors.email}
                  helperText={validationErrors.email}
                  className={formItem}
                />
              )}
            </Grid>

            {openModal && (
              <EmailFindModal
                open={true}
                onClose={onClosePop}
                history={history}
              />
            )}

            <Grid item xs={12} className={formControl}>
              <TextField
                fullWidth
                label="Phone Number"
                name="phone"
                value={formInfo.phone || ''}
                variant="outlined"
                error={validationErrors.phone}
                helperText={validationErrors.phone}
                onChange={handleChange}
                InputProps={{
                  inputComponent: PhoneInput,
                }}
                className={formItem}
              />
            </Grid>
          </>
        )}

        <Grid item xs={12} className={formControl}>
          <FormControl component="fieldset">
            <FormControlLabel
              control={
                <Checkbox
                  checked={addressConfirmed}
                  onChange={event => {
                    setAddressConfirmed(event.target.checked);

                    setValidationErros(prev => ({
                      ...prev,
                      addressConfirmed: '',
                    }));
                  }}
                  color="primary"
                />
              }
              label="I confirm that the address information listed below is correct"
            />

            {validationErrors.addressConfirmed && (
              <FormLabel error>
                {validationErrors.addressConfirmed}
              </FormLabel>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} className={formControl}>
          <TextField
            fullWidth
            label="Address Line 1"
            name="addressLine1"
            value={formInfo.addressLine1 || ''}
            variant="outlined"
            error={!!validationErrors.addressLine1}
            helperText={validationErrors.addressLine1}
            onChange={handleChange}
            className={formItem}
          />
        </Grid>

        <Grid item xs={12} className={formControl}>
          <TextField
            fullWidth
            label="Address Line 2"
            name="addressLine2"
            value={formInfo.addressLine2 || ''}
            variant="outlined"
            error={validationErrors.addressLine2}
            helperText={validationErrors.addressLine2}
            onChange={handleChange}
            className={formItem}
          />
        </Grid>

        <Grid item xs={12} className={formControl}>
          <TextField
            fullWidth
            label="City"
            name="city"
            value={formInfo.city || ''}
            variant="outlined"
            error={!!validationErrors.city}
            helperText={validationErrors.city}
            onChange={handleChange}
            className={formItem}
          />
        </Grid>

        <Grid item xs={12} className={formControl}>
          <Autocomplete
            options={STATES_LIST}
            getOptionLabel={option =>
              option ? `${option.code} - ${option.name}` : ''
            }
            value={
              STATES_LIST.find(option => option.code === formInfo.state) || null
            }
            onChange={(_, value) => {
              setFormInfo(prev => ({
                ...prev,
                state: value?.code || '',
              }));
              // setValidationErros(prev => ({
              //   ...prev,
              //   state: false,
              // }));
            }}
            renderInput={params => (
              <TextField
                {...params}
                fullWidth
                label="State"
                name="state"
                variant="outlined"
                error={!!validationErrors.state}
                helperText={validationErrors.state}
                className={formItem}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} className={formControl}>
          <TextField
            fullWidth
            label="Zip Code"
            name="zipcode"
            value={formInfo.zipcode || ''}
            variant="outlined"
            error={validationErrors.zipcode}
            helperText={validationErrors.zipcode}
            onChange={handleChange}
            className={formItem}
          />
        </Grid>

        <Grid item xs={12} className={formControl}>
          <FormControl component="fieldset">
            <FormControlLabel
              control={
                <Checkbox
                  checked={insuranceConfirmed}
                  onChange={event => {
                    setInsuranceConfirmed(event.target.checked);

                    setValidationErros(prev => ({
                      ...prev,
                      insuranceConfirmed: '',
                    }));
                  }}
                  color="primary"
                />
              }
              label="I confirm that the insurance information listed below is correct"
            />

            {validationErrors.insuranceConfirmed && (
              <FormLabel error>
                {validationErrors.insuranceConfirmed}
              </FormLabel>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12} lg={12}>
          <Autocomplete
            options={insurancePlans}
            getOptionLabel={option =>
              option ? `${option.companyName} - ${option.planName} (${option.payerId})` : ''
            }
            filterOptions={(options, { inputValue }) => {
              const searchValue = inputValue.toLowerCase();

              return options.filter(
                option =>
                  option.companyName?.toLowerCase().includes(searchValue) ||
                  option.planName?.toLowerCase().includes(searchValue) ||
                  option.payerId?.toLowerCase().includes(searchValue)
              );
            }}
            value={
              insurancePlans.find(
                item => item.id === formInfo.insurancePlanId
              ) || null
            }
            onChange={(event, newValue) => {
              setFormInfo(prev => ({
                ...prev,
                insuranceName: newValue?.planName || '',
                payerId: newValue?.payerId || '',
                insurancePlanId: newValue?.id || null,
              }));
            }}
            renderInput={params => (
              <TextField
                {...params}
                fullWidth
                variant="outlined"
                label="Insurance Name / Payer ID"
                error={!!validationErrors.insurancePlanId}
                helperText={validationErrors.insurancePlanId}
                className={formItem}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={12}>
          <TextField
            fullWidth
            InputProps={{
              readOnly: true,
              disabled: true
            }}
            name="payerId"
            variant="outlined"
            label="Payer ID"
            value={formInfo.payerId || ''}
            onChange={handleChange}
            className={formItem}
          />
        </Grid>

        <Grid item xs={12} lg={6}>
          <TextField
            fullWidth
            name="insuranceId"
            variant="outlined"
            label="Insurance ID"
            value={formInfo.insuranceId || ''}
            onChange={handleChange}
            error={!!validationErrors.insuranceId}
            helperText={validationErrors.insuranceId}
            className={formItem}
          />
        </Grid>

        { !insuranceWithoutGroupNumber?.includes(formInfo.insurancePlanId) && <Grid item xs={12} lg={6}>
          <TextField
            fullWidth
            name="groupNumber"
            variant="outlined"
            label="Group Number"
            value={formInfo.groupNumber || ''}
            onChange={handleChange}
            error={!!validationErrors.groupNumber}
            helperText={validationErrors.groupNumber}
            className={formItem}
          />
        </Grid>}
        <Grid item xs={12}>
          <FormHelperText
            className={helperText}
            style={{ color: '#055C9D', fontSize: '11px' }}
          >
            <WbIncandescentIcon fontSize="small" className="inv-bulb-icon" />
            We encourage you to enter your insurance information here, to help
            minimize your wait time at the time of your appointment{' '}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} classes={container} style={{ marginBottom: '15px' }}>
          <FormLabel component="legend">Upload insurance front</FormLabel>
          <input
            type="file"
            ref={myRef}
            onChange={event => callSetImageFront(event)}
            className="custom-mt-10"
            style={{ color : previewFront ? "" : "transparent" }}
          />
        </Grid>
        <Grid item xs={12} classes={container}>
          <FormLabel component="legend">Upload insurance back</FormLabel>
          <input
            type="file"
            ref={myRef}
            onChange={event => callSetImageBack(event)}
            className="custom-mt-10"
            style={{ color : previewBack ? "" : "transparent" }}
          />
        </Grid>

        {!formInfo.existingPatient && (
          <>
            <Grid item xs={12} className={formControl}>
              <FormControl component="fieldset" variant="filled">
                <FormLabel className={insuranceLabel} component="legend">
                  Gender (as listed on health insurance card)
                </FormLabel>
                <RadioGroup
                  row
                  aria-label="Gender"
                  name="gender"
                  value={formInfo.gender || ''}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="Female"
                  />
                  <FormControlLabel
                    value="male"
                    control={<Radio />}
                    label="Male"
                  />
                </RadioGroup>
                {validationErrors.gender && (
                  <FormLabel component="legend" className={warning}>
                    {validationErrors.gender}
                  </FormLabel>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} className={formControl}>
              <DateSelect
                label="Birthdate"
                disableFuture
                fullWidth
                format="MM/DD/YYYY"
                placeholder="MM/DD/YYYY ex. 01/01/2001"
                variant="outlined"
                value={new Date(formInfo.birthdate)}
                onChange={handleDateChange}
                error={validationErrors.birthdate}
                helperText={validationErrors.birthdate}
              />
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows="4"
            variant="outlined"
            label="Visit Reason"
            name="patientReason"
            value={formInfo.patientReason || ''}
            onChange={handleChange}
            error={validationErrors.patientReason}
            helperText={validationErrors.patientReason}
            className={formItem}
          />
        </Grid>

        {!formInfo.existingPatient && (
          <>
            <Grid item xs={12} className={formControl}>
              <FormControl
                required
                label="termsOfUse"
                error={!formInfo.termsOfUse}
              >
                <div className={labelWithLink}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formInfo.termsOfUse}
                        value="termsOfUse"
                        name="termsOfUse"
                        onChange={handleChange}
                      />
                    }
                    label="I have read and accept Qwell's Terms of Use."
                  />
                  <Link
                    href={
                      process.env.REACT_APP_HOMEPAGE_URL +
                      '/patients-terms-of-use/'
                    }
                    target="_blank"
                    rel="noopener"
                  >
                    <LaunchedOutlinedIcon className="icon" />
                  </Link>
                </div>
                <FormHelperText>
                  {!formInfo.termsOfUse ? validationErrors.termsOfUse : ''}
                </FormHelperText>
              </FormControl>

              <FormControl
                required
                label="privPolicy"
                error={!formInfo.privPolicy}
              >
                <div className={labelWithLink}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formInfo.privPolicy}
                        value="privPolicy"
                        name="privPolicy"
                        onChange={handleChange}
                      />
                    }
                    label="I have read and accept Qwell's Privacy Policy."
                  />
                  <Link
                    href={
                      process.env.REACT_APP_HOMEPAGE_URL + '/privacy-policy'
                    }
                    target="_blank"
                    rel="noopener"
                  >
                    <LaunchedOutlinedIcon className="icon" />
                  </Link>
                </div>
                <FormHelperText>
                  {!formInfo.privPolicy ? validationErrors.privPolicy : ''}
                </FormHelperText>
              </FormControl>
            </Grid>
          </>
        )}
        <Grid container item xs={12}>
          <FormLabel component="legend">Add attachments</FormLabel>
          <Grid item xs={12}>
            <input
              className={attachmentsBtn}
              ref={myRef}
              type="file"
              multiple
              onChange={event =>
                fileSelectHandler(
                  event.target.files,
                  inputPicCallBackProps,
                  ['jpg', 'jpeg', 'pdf'],
                  1048576 // 1048576 bytes = 1MB
                )
              }
            />
          </Grid>
        </Grid>
        {imagesProps.length > 0 && isMobile ? (
          <div>{imagesProps.length} images attached</div>
        ) : (
          imagesProps.map((image, index) =>
            image.fileType === 'pdf' ? (
              <Grid container item xs={12}>
                <Grid item xs={12}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => handleOpenPDF(image.dataUrl)}
                  >
                    Click to Preview
                  </Button>
                  <a
                    className="custom-popup-download-btn"
                    target="_blank"
                    href={image && image.dataUrl}
                    download
                  >
                    Download
                  </a>
                </Grid>
                {/* <Document file={image.dataUrl} options={options} className={previewImg}>
                      <Page pageNumber={1} />
                    </Document> */}

                <PDFSingleViewer
                  openPDFModal={openPDFModal}
                  currentPDF={currentPDF}
                  onClose={() => setOpenPDFModal(false)}
                />
              </Grid>
            ) : (
              <Grid container item xs={12}>
                <Grid item xs={12}>
                  <Button
                    // disabled={!imagePreview}
                    disabled={
                      image?.fileType === 'htm' || image?.fileType === 'html'
                    }
                    color="primary"
                    variant="contained"
                    onClick={() => handleOpenImg(image.dataUrl)}
                  >
                    Click to Preview
                  </Button>
                  <a
                    className="custom-popup-download-btn"
                    target="_blank"
                    href={image && image.dataUrl}
                    download
                  >
                    Download
                  </a>
                </Grid>

                {/* <img src={ image && image.dataUrl} key={`picture-${index}`} onError={()=>setImagePreview(false)} alt="To see full report, please download the file" className={previewImg} /> */}
                <ImgSingleViewer
                  openImgModal={openImgModal}
                  currentImg={currentImg}
                  onClose={() => setOpenImgModal(false)}
                />
              </Grid>
            )
          )
        )}

        <div className={actions}>
          <Button
            onClick={onCancel}
            variant="outlined"
            color="primary"
            className={cancelButton}
          >
            Cancel
          </Button>

          {!formInfo.existingPatient ? (
            <Button
              color="primary"
              variant="contained"
              onClick={handleSubmit}
              className={submitButton}
              disabledDuringOnClick={true}
              onClickValidation={validate}
            >
              {isAptRequest ? 'Request Appointment' : 'Book Appointment'}
            </Button>
          ) : (
            <Button
              color="primary"
              variant="contained"
              onClick={handleSubmit}
              className={submitButton}
              disabledDuringOnClick={true}
              onClickValidation={validate}
            >
              {isAptRequest ? 'Request Appointment' : 'Book Appointment'}
            </Button>
          )}

          {/* <Button
            color="primary"
            variant="contained"
            onClick={handleSubmit}
            className={submitButton}
            disabledDuringOnClick={true}
            // onClickValidation={validate}
          >
            {isAptRequest ? 'Request Appointment' : 'Book Appointment'}
          </Button> */}
        </div>
      </Grid>
      <div>
        <ProviderRestrictedModal
          open={showProviderRestrictedModal}
          onClose={nullifyStateAndClosePopup}
          providerFamily={providerFamily}
        />
        <PatientRestrictForProvider
          open={showPatientRestrictPopUp}
          onClose={nullifyStateAndClosePatientPopup}
        />
      </div>
      <AreYouSureModal
        open={openLoginWarning}
        onClose={() => setOpenLoginWarning(false)}
        confirmButtonTag="Go to login"
        message="To proceed you must login"
        executMethod={() => {
          localStorage.setItem('info', JSON.stringify(history.location));
          history.push('/login?redirect=back');
        }}
      />
      {isRestricted && (
        <PatientNotAllowToBookApptModal
          open={isRestricted}
          onClose={() => closePopUp()}
        />
      )}
      {showPatientRestrictModal && (
        <PatientRestrictForAppt
          open={showPatientRestrictModal}
          onClose={onClosePatientRestrictModal}
          restrictReason={restrictReason}
          temp="scene 1"
        />
      )}
      {isPatientRestrict && (
        <PatientRestrictForAppt
          open={isPatientRestrict}
          onClose={() => closePopUpForPatient()}
          restrictReason={restrictReason}
          temp="scene 2"
        />
      )}
      {popNotice && (
        <NoticeDialog
          open={popNotice}
          onOkClick={() => setPopNotice('')}
          noticeTitle="Notice"
          message={popNotice}
        />
      )}
    </Grid>
  );
}

const styles = () => ({
  container: {
    width: '100%',
  },
  formControl: {
    margin: '0em',
    padding: '0em',
  },
  actions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    '@media only screen and (max-width: 1024px)': {
      flexDirection: 'column-reverse',
      justifyContent: 'center',
    },
  },
  submitButton: {
    color: 'white',
    minWidth: '50%',
    marginLeft: '15px',
    '@media only screen and (max-width: 1024px)': {
      padding: '1em',
      marginLeft: '0',
      marginBottom: '1em',
    },
  },
  cancelButton: {
    minWidth: '38%',
  },
  labelWithLink: {
    display: 'flex',
    alignItems: 'center',
  },
  warning: {
    color: '#e25141',
    fontSize: '12px',
  },
  formItem: {
    backgroundColor: 'white',
  },
  loadingCircle: {
    minHeight: '400px',
  },
  helperText: {
    marginLeft: '10px',
  },
  attachmentsBtn: {
    paddingBottom: '5px',
  },
  insuranceLabel: {
    fontWeight: 'bold',
  },
  addressLabel: {
    fontWeight: 'bold',
  },
});

export default withStyles(styles)(PatientInformationForm);
  